import {
  parseSearchNumberValue,
  parseSearchStringValue,
  parseSearchArrayValue,
} from 'infrastructure/functions/parse-query-string';
import { RangeTypes } from 'infrastructure/enums';
import { endOfDay, startOfDay } from 'date-fns';

import { useQueryFilterNew } from '../common/use-query-param-new';

import type { TParseFunctions } from '../common/use-query-param-new';
import type { ISmsMetricsFilters } from 'infrastructure/interfaces';

const date = new Date();

const defaultFilter: ISmsMetricsFilters = {
  startTime: startOfDay(date).getTime(),
  endTime: endOfDay(date).getTime(),
  rangeType: RangeTypes.Daily,
};

const parseFunctions: TParseFunctions<ISmsMetricsFilters> = {
  startTime: parseSearchNumberValue,
  endTime: parseSearchNumberValue,
  rangeType: parseSearchStringValue,
  status: parseSearchArrayValue,
  smsType: parseSearchArrayValue,
};

export const useSmsMetricsQueryFilterNew = () => {
  return useQueryFilterNew<ISmsMetricsFilters>(
    defaultFilter,
    parseFunctions,
    [],
  );
};
